const reportPaths = {
  REPORT_SEARCH: "search",
  REPORT_DOWNLOAD: (id) => `${id}/download`,
  DELETE_REPORT: (id) => `${id}`,
};

export default reportPaths;
